'use client';

import { FloatingPortal } from '@floating-ui/react';
import { useContext } from 'react';

import { DatePickerRootContext } from './context/date-picker-root.context';
import type { DatePickerPortalPropsInterface } from './types/date-picker-portal.types';

/**
 * @since 10.0.0
 */
export const DatePickerPortal = (props: DatePickerPortalPropsInterface) => {
  const { datePicker } = useContext(DatePickerRootContext);

  if (!datePicker?.isMounted) {
    return null;
  }

  return <FloatingPortal {...props} />;
};

DatePickerPortal.displayName = 'DatePicker.Portal';
